<div class="login-shell default-theme" data-cy="iot-platform-login-callback">
  <div class="login-shell-row flex flex-row max-[959px]:flex-col">
    <div class="login-shell-col max-w-1/2 flex-[1_1_50%] max-[959px]:max-w-full max-[959px]:flex-[1_1_100%]"></div>
    <div class="login-shell-col flex max-w-1/2 flex-[1_1_50%] flex-col max-[959px]:max-w-full max-[959px]:flex-[1_1_100%]">
      <h1 class="login-shell-title">{{ authConfig.appName }}</h1>

      <h2>{{ 'LOGIN.AUTH_IN_PROGRESS' | translate }}</h2>
      <div class="flex h-full flex-col items-center justify-center">
        <mat-progress-spinner [diameter]="90" color="accent" mode="indeterminate" />
      </div>
    </div>
  </div>
</div>
